<template>
    <section :class="{'py-6': phoneOnly, 'py-12': pcOnly}" :style="style">
        <v-container>
            <v-row :class="{'flex-row-reverse': reverse}">
                <v-col :cols="pcOnly ? 5 : 12" :class="{'ltr-dir': reverse}">
                    <img v-if="img" :src="asset(img, 'img')" :style="`max-width: ${phoneOnly ? '100%' : '400px'}`" />
                    <slot v-else name="img" />
                </v-col>
                <v-col :cols="pcOnly ? 7 : 12" :class="{'py-6': phoneOnly, 'py-12': pcOnly}">
                    <h1 v-if="headline" class="headline">{{headline}}</h1>
                    <slot v-else name="headline"></slot>
                    <p v-if="description" class="description mb-0 grey--text mt-5">{{description}}</p>
                    <slot v-else name="description"></slot>

                    <div class="actions mt-8">
                        <slot name="actions"></slot>
                        <v-btn v-if="button1" large depressed color="primary" class="font-weight-bold" :to="button1.to">
                            <v-icon v-if="button1.icon" class="ml-2">{{button1.icon}}</v-icon>
                            <span>{{button1.text}}</span>
                        </v-btn>
                        <v-btn v-if="button2" large depressed color="secondary" outlined class="font-weight-bold mr-3" :to="button2.to">
                            <v-icon v-if="button1.icon" class="ml-2">{{button2.icon}}</v-icon>
                            <span>{{button2.text}}</span>
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: ['img', 'headline', 'description', 'button1', 'button2', 'background', 'reverse'],
    data(){
        return {

        }
    },
    computed: {
        ...GlobalComputed,
        style(){
            let style = '';
            if (this.background){
                style += 'background: ' + this.background;
            }
            return style;
        }
    },
    methods: {
        ...GlobalMethods,
    },

}
</script>

<style lang="scss" scoped>

    section{
        .headline{
            font-size: 2rem!important;
            line-height: 3rem!important;
        }
        .description{
            line-height: 2rem!important;
        }
    }

    @media(max-width: 960px){
        section{

            .headline{
                font-size: 1.65rem!important;
                line-height: 2.7rem!important;
            }
            .actions, .headline, .description{
                text-align: center;
                justify-content: center;
            }
        }
    }
</style>